import type { Card } from '../../types';

export const PLAGUE: Card = {
  id: 'plague',
  name: 'Plague',
  type: 'support',
  rarity: 'rare',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'min', value: 4 }],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'poison', magnitude: 4, duration: 3, target: 'opponent' },
    },
  ],
};
